export const prevArrow = `
    <button aria-label="Previous slide" class="slider__arrow slider__prev slick-prev button button--ghost arrow-button">
        <svg class="icon icon--prev" xmlns="http://www.w3.org/2000/svg" width="25" height="13.713" viewBox="0 0 25 13.713" style="transform: rotate(180deg)">
            <path d="M0 6.518h23.422M17.46.685l6.172 6.172-6.172 6.172" fill="none" stroke="currentColor" stroke-width="1.937" />
        </svg>
        <svg class="icon icon--screw" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="5.714 5.714 80 80" width="80" height="80">
            <path clip-rule="evenodd" d="m45.714 45.695 -0.057 -19.048L45.6 7.619 22.857 26.667v19.048zm0.019 0.019 19.048 -0.057 19.029 -0.057 -19.048 -22.743h-19.048zm-0.019 0.019 0.057 19.048 0.057 19.048L68.571 64.762v-19.048zM45.695 45.714l-19.048 0.057 -19.029 0.057 19.048 22.743h19.048z" stroke="currentColor" stroke-width="3.8095238095238098" fill="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="slider__arrow slider__next slick-next button button--ghost arrow-button">
        <svg class="icon icon--next" xmlns="http://www.w3.org/2000/svg" width="25" height="13.713" viewBox="0 0 25 13.713" style="transform: rotate(0deg)">
            <path d="M0 6.518h23.422M17.46.685l6.172 6.172-6.172 6.172" fill="none" stroke="currentColor" stroke-width="1.937" />
        </svg>
        <svg class="icon icon--screw" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="5.714 5.714 80 80" width="80" height="80">
            <path clip-rule="evenodd" d="m45.714 45.695 -0.057 -19.048L45.6 7.619 22.857 26.667v19.048zm0.019 0.019 19.048 -0.057 19.029 -0.057 -19.048 -22.743h-19.048zm-0.019 0.019 0.057 19.048 0.057 19.048L68.571 64.762v-19.048zM45.695 45.714l-19.048 0.057 -19.029 0.057 19.048 22.743h19.048z" stroke="currentColor" stroke-width="3.8095238095238098" fill="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease-in-out',
    speed: 300,
    nextArrow,
    prevArrow
};

